import * as styles from './index.module.scss';
import { observer } from 'mobx-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { StagesStore } from '../../../../../DataSource/Stores/Cabinet/StagesStore';
import { Collapse, Flex, message } from 'antd';
import Icon from '../../../../ui/Icon';
import Clickable from '../../../../ui/Clickable';
import IconButton from '../../../../ui/IconButton';
import { SwipeableButton } from 'react-swipeable-button';
import CommentsBlock from '../CommentsBlock';
import ReferenceBlock from '../ReferenceBlock';
import { UpOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import MultipleImagesUpload from './MultipleImagesUpload';

const TaskPage = () => {
  const { id: workspaceId, taskId } = useParams();
  const navigate = useNavigate();
  const swipeableButtonRef = useRef<SwipeableButton | null>(null);
  const task = StagesStore.dataMyTaskOpened;
  const job = StagesStore.dataJobs.job;

  useEffect(() => {
    if (!workspaceId || !taskId) return;

    StagesStore.getMyTaskOpen(workspaceId, taskId)
      .then(() => {
        StagesStore.setSelectedTask(StagesStore.dataMyTaskOpened);
        StagesStore.setIsSelectedTask(true);
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  useEffect(() => {
    if (!workspaceId || !task?.jobId) return;

    StagesStore.getJobsId(workspaceId, task.jobId).catch((e) => {
      console.error(e);
    });
  }, [task?.jobId]);

  const copy = async (value?: string) => {
    if (!value) {
      message.error('Ошибка');
      return;
    }

    try {
      await navigator.clipboard.writeText(value);
      message.info('Скопировано', 2);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSwipe = async () => {
    if (!workspaceId || !task?.jobId) return;

    swipeableButtonRef.current?.buttonReset();

    await StagesStore.updateTask(workspaceId, task._id, 'completed');
    if (StagesStore.taskUpdateError) {
      message.error('Ошибка');
    } else {
      message.info('Успешно');
      navigate(`/workspaces/${workspaceId}/mobile/in-work`);

      StagesStore.getMyTasks(workspaceId).catch((e) => {
        console.error(e);
      });
    }
  };

  const expandIcon = ({ isActive }: any) => (
    <UpOutlined style={{ transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)' }} />
  );

  return (
    <Flex vertical gap={24}>
      <Clickable
        className={styles.backBtn}
        onClick={() => navigate(`/workspaces/${workspaceId}/mobile/in-work`)}
      >
        <Icon slug="arrow_back" />
        Все "В работе"
      </Clickable>

      <Flex vertical gap={12}>
        <p className={styles.name}>{job?.name}</p>

        <Flex vertical gap={8}>
          <div className={styles.field}>
            <p className={styles.label}>Job ID:</p>
            <Flex align="center" gap={8}>
              <p className={styles.value}>{job?.jobId}</p>
              <IconButton
                icon="copy_icon"
                variant="clear"
                size="sm"
                onClick={() => copy(job?.jobId)}
              />
            </Flex>
          </div>

          <div className={styles.field}>
            <p className={styles.label}>Bitrix ID:</p>
            <Flex align="center" gap={8}>
              <p className={styles.value}>{job?.externalId?.bitrixId}</p>
              <IconButton
                icon="copy_icon"
                variant="clear"
                size="sm"
                onClick={() => copy(job?.externalId?.bitrixId)}
              />
            </Flex>
          </div>
        </Flex>

        <Collapse
          items={[
            {
              key: '1',
              label: 'ФОТО ГОТОВОГО ПРОДУКТА',
              children: (
                <MultipleImagesUpload
                  images={StagesStore?.dataJobs?.job?.prodImages}
                  workspaceId={workspaceId}
                  jobId={task?.jobId}
                />
              ),
            },
          ]}
          expandIcon={expandIcon}
          expandIconPosition="right"
          bordered={false}
          defaultActiveKey={[1]}
          ghost
        />

        {job?.jobData && <ReferenceBlock jobData={job.jobData} expandIcon={expandIcon} />}

        <Collapse
          items={[
            {
              key: '1',
              label: 'СРОКИ',
              children: (
                <div className={styles.field}>
                  <p className={styles.label}>Цель</p>
                  <Flex align="center" gap={8}>
                    <p className={styles.label}>{dayjs(job?.targetDate).format('HH : mm')}</p>
                    <p className={styles.label}>•</p>
                    <p className={styles.label}>{dayjs(job?.targetDate).format('DD/MM/YY')}</p>
                  </Flex>
                </div>
              ),
            },
          ]}
          expandIcon={expandIcon}
          expandIconPosition="right"
          bordered={false}
          defaultActiveKey={[1]}
          ghost
        />

        {!!job?.comments?.length && (
          <CommentsBlock comments={job.comments} expandIcon={expandIcon} />
        )}
      </Flex>

      <SwipeableButton
        ref={swipeableButtonRef}
        text={StagesStore.viewButtonFinish ? 'Завершить' : 'Загрузите фото'}
        textColor="white"
        sliderColor="white"
        sliderIconColor="#E1A719"
        sliderTextColor="#E1A719"
        circle
        noAnimate
        disabled={!StagesStore.viewButtonFinish}
        onSuccess={handleSwipe}
      />
    </Flex>
  );
};

export default observer(TaskPage);
